module.exports = __webpack_public_path__ + "img/amsbannner3.f8ec761b.png";